module.exports = __webpack_public_path__ + "img/c05_buildingtechaqueducts_Normal_ua.a77d544e.webp";